export const SEARCH_DRAG = 'search_result_drag' as const;

export type DragName = typeof SEARCH_DRAG;
